// Page Path :  src\pages\design\document\configuration\canvas.tsx

import { RefCallback } from 'react';

interface Props {
  canvasRef: RefCallback<HTMLCanvasElement | null | any>;
}

const FabricImageCanvas = ({ canvasRef }: Props) => {
  return <canvas ref={canvasRef} />;
};

export default FabricImageCanvas;
